import { createSlice } from '@reduxjs/toolkit';

import { IAuthState } from 'src/features/auth/domain/types';

import { login } from './authThunks';

// Load initial state from localStorage
const loadInitialState = (): IAuthState => {
	const access = localStorage.getItem('access_token');
	const refresh = localStorage.getItem('refresh_token');

	return {
		loading: false,
		error: null,
		access: access || null,
		refresh: refresh || null,
		user_type: null,
	};
};

const authSlice = createSlice({
	name: 'auth',
	initialState: loadInitialState(),
	reducers: {
		logout: (state) => {
			state.access = null;
			state.refresh = null;
			state.error = null;
			state.user_type = null;
			// Clear tokens from localStorage
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
		},
		setAuthInfo: (state, action) => {
			state.access = action.payload.access;
			state.refresh = action.payload.refresh;
			state.user_type = action.payload.user_type;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(login.fulfilled, (state, action) => {
				state.access = action.payload.access;
				state.refresh = action.payload.refresh;
				state.user_type = action.payload.type;
				state.error = null;
			})
			.addCase(login.rejected, (state, action) => {
				state.error =
					action.payload?.description ||
					action.error.message ||
					'Login failed';
			});
	},
});

export const { logout, setAuthInfo } = authSlice.actions;
export default authSlice.reducer;
